import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { EncriptyUtilService } from '../../shared/services/encripty-util.service';
import { ResetSenhaService } from './reset-senha.service';
import { environment } from '../../../environments/environment';
import { ModalFalhaLoginComponent } from '../login/modal-falha-login/modal-falha-login.component';
import { NbDialogService } from '@nebular/theme';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ngx-reset-senha',
  templateUrl: './reset-senha.component.html',
  styleUrls: ['./reset-senha.component.css']
})

export class ResetSenhaComponent implements OnInit {

  resetSenhaForm: FormGroup;
  private login: any = null;
  private dominio: any = null;
  public customLogin = null;
  captchaToken = null;

  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private notifications: NotificationsService,
    private encriptyService: EncriptyUtilService,
    private ResetSenhaService: ResetSenhaService,
    private cd: ChangeDetectorRef,
    private dialogService: NbDialogService,
    private spinnerService: NgxSpinnerService,
  ) {

    this.route.queryParamMap.subscribe(params => {
      this.login = this.encriptyService.decriptyBySecretKey(params.get('login'))
      this.dominio = this.encriptyService.decriptyBySecretKey(params.get('dominio'))
    });

    this.resetSenhaForm = this.formBuilder.group({

      login: [this.login],
      dominio: [this.dominio],

    });


  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.addRecaptchaScript();
  }

  resetarSenha(data) {

    if (this.captchaToken != null) {
      this.spinnerService.show();

      this.ResetSenhaService.enviarPassword(data)
        .subscribe((response) => {
          this.spinnerService.hide();

          const content = {
            titulo: 'Alterar senha',
            subtitulo: 'Sucesso',
            mensagem: response['mensagem'],
          };

          this.dialogService.open(ModalFalhaLoginComponent, {
            context: {
              data: content,
            },
          }).onClose.subscribe(_res => {
            this.router.navigate(['/login']);
          });

        }, (error) => {
          this.spinnerService.hide();

          let content:any;

          if (error.status == 401 && error.error.titulo != null 
            && error.error.subtitulo != null && error.error.mensagem != null) {

            content = {
              titulo: error.error.titulo,
              subtitulo: error.error.subtitulo,
              mensagem: error.error.mensagem,
            };            

          } else {

            content = {
              titulo: 'Usuário inválido!',
              subtitulo: 'Atenção!',
              mensagem: error.error.mensagem,
            };            
            
          }

          this.dialogService.open(ModalFalhaLoginComponent, {
            context: {
              data: content,
            },
          }).onClose.subscribe(_res => {
            this.router.navigate(['/login']);
          });

        });

      this.resetSenhaForm = this.formBuilder.group({

        login: [null],
        dominio: [null],
      });

    } else {
      this.notifications.error('reCAPTCHA é obrigatório!');
    }

  }

  getLoginLogo() {
    return this.customLogin && this.customLogin.logo ? 'url(data:image/png;base64,' + this.customLogin.logo + ') no-repeat left/cover' : './../images/'
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  addRecaptchaScript() {

    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    };

    (function (d, s, id, obj) {
      let js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        obj.renderReCaptcha();
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render=explicit';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));

  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey': environment.recaptcha.siteKey,
      'callback': (response) => {
        this.startExpirationTimer(response);
      },
    });
  }

  startExpirationTimer(res) {
    this.captchaToken = res;
    this.cd.detectChanges();
    setTimeout(() => {
      this.captchaToken = null;
      this.cd.detectChanges();
    }, 60000);
  }

}
